import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class ContactUs extends Component {
  state = {
    name: '',
    email: '',
    phone: '',
    message: '',
    emailStatus: '',
  };

  handleCHange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  submitForm = (e) => {
    e.preventDefault();
    const { name, email, phone, message } = this.state;

    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      this.setState({ emailStatus: xhr.responseText });
    });
    xhr.open(
      'GET',
      `https://email.clinicaveterinarialoscuartos.net/index.php?sendto=${encodeURIComponent(email)}&name=${encodeURIComponent(name)}&phone=${encodeURIComponent(phone)}&message=${encodeURIComponent(message)}`
    );
    xhr.send();

    this.setState({
      name: '',
      email: '',
      phone: '',
      message: '',
    });
  };

  render() {
    const { name, email, phone, message, emailStatus } = this.state;
    const { t } = this.props;

    return (
      <div className="formBlock">
        {emailStatus ? <p className="form-status">{emailStatus}</p> : null}
        <form onSubmit={this.submitForm}>
          <label>
            <input
              className="text-input"
              type="text"
              value={name}
              onChange={this.handleCHange('name')}
              placeholder={t('formulario.nombre')}
              required
            />
          </label>
          <label>
            <input
              className="text-input"
              type="email"
              value={email}
              onChange={this.handleCHange('email')}
              placeholder={t('formulario.email')}
              required
            />
          </label>
          <label>
            <input
              className="text-input"
              type="tel"
              value={phone}
              onChange={this.handleCHange('phone')}
              placeholder={t('formulario.telefono')}
            />
          </label>
          <label>
            <textarea
              className="text-input"
              value={message}
              onChange={this.handleCHange('message')}
              placeholder={t('formulario.mensaje')}
              required
            />
          </label>
          <label>
            <input className="learn-more" type="submit" value={t('formulario.btnForm')} />
          </label>
        </form>
      </div>
    );
  }
}

export default withTranslation('global')(ContactUs);
